require('normalize.css/normalize.css')
require('../css/main.css')
require('../partials/nav.js')





